import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../Services/Account/EncryptionToken";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import {
  ChangeTransferStatusById,
  GetReportStatusByApplicationGuid,
  TransferValidationManagerEmployee,
} from "../../Redux/Reducers/ReportStage/TransferItemInformation";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { ChangeRportStatusByAppGUID } from "../../Redux/Reducers/ReportStage/Report";
import $ from "jquery";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
const TransferItemInformationEmployee = (props) => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const [pR_TransferItemInformationGuid, setpR_TransferItemInformationGuid] =
    useState();
  const navigate = useNavigate();
  const state = useSelector((state) => {
    return {
      ReportStatusByApplicationGuid:
        state.TransferItemInformation.ReportStatusByApplicationGuid,
      ReportByApp: state.TypeOfJobOpportunityDropDown.ReportByApp,
    };
  });
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false); // Popup visibility state

  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "stageFromTransferName",
      ShowStatus: true,
      NmaeColumn: " المرحلة التي تمت المناقلة منها ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemTypeFromName",
      ShowStatus: true,
      NmaeColumn: "نوع البند الذي تمت المناقلة منه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemFromTransferName",
      ShowStatus: true,
      NmaeColumn: "اسم البند الذي تمت المناقلة منه ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "stageToTransferName",
      ShowStatus: true,
      NmaeColumn: " المرحلة التي تمت المناقلة اليها",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemTypeToName",
      ShowStatus: true,
      NmaeColumn: "نوع البند الذي تمت المناقلة اليه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemToTransferName",
      ShowStatus: true,
      NmaeColumn: "اسم البند الذي تمت المناقلة اليه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "transferValue",
      ShowStatus: true,
      NmaeColumn: "قيمة المناقلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusName",
      ShowStatus: true,
      NmaeColumn: "حالة طلب المناقلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        Swal.fire({
          title: "تأكيد على الموافقة على المناقلة",
          icon: "info",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          // Callback triggered after user interacts with the popup.
          if (res.isConfirmed == true) {
            // If the user confirms the action:
            const deleted = await dispatch(
              ChangeTransferStatusById({
                pR_TransferItemInformationGUID: e.target.value,
                pR_TransferInformationStatusGUID:
                  "aada2135-dc2e-42fe-aa2d-81805be622be",
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تمت العملية بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-check-circle",
      id: "AddAppBtn",
      title: "الموافقة على المناقلة",
      ShowStatus: true,
    },

    {
      Click: async (e) => {
        Swal.fire({
          title: "تأكيد على رفض المناقلة",
          icon: "info",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          // Callback triggered after user interacts with the popup.
          if (res.isConfirmed == true) {
            // If the user confirms the action:
            const deleted = await dispatch(
              ChangeTransferStatusById({
                pR_TransferItemInformationGUID: e.target.value,
                pR_TransferInformationStatusGUID:
                  "fc544ec0-ecda-448a-a990-303e0de0287b",
              })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تمت العملية بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-x-circle",
      id: "deleteBtn",
      title: "رفض المناقلة",
      ShowStatus: !props.shouldDisableFields,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div>{/* <AddEditeTransferInformation /> */}</div>,

    title: "المناقلات",
    maxWidth: "31%",
    maxHeight: "40%",
    idssss: "",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <div>
        {/* <AddEditeTransferInformation
          pR_TransferItemInformationGuid={pR_TransferItemInformationGuid}
        /> */}
      </div>
    ),

    title: "المناقلات",
    maxWidth: "31%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };
  const ApplayTransfer = async (status, popUpText) => {
    // const validat = await dispatch(
    //   TransferValidationManagerEmployee({
    //     aI_ApplicationInformationId: props.applicationInformationGuid,
    //   })
    // );
    // console.log(validat.payload, "validat.payload");

    // if (validat.payload?.length == 0) {
    Swal.fire({
      position: "center",
      icon: "info",
      title: ` تأكيد على ${popUpText} على الطلب`,
      showConfirmButton: true,
      confirmButtonText: "تأكيد",
      cancelButtonText: "الغاء",
      showCancelButton: true,
      showCloseButton: true,
      //   timer: 1500,
      // width: "500px",
    }).then(async (res) => {
      if (res.isConfirmed) {
        const applay = await dispatch(
          ChangeRportStatusByAppGUID({
            PR_ReportStatusGuid: status,
            AP_ApplicationInformationGUID: props.applicationInformationGuid,
          })
        );

        $(".close-btn").trigger("click");
      }
    });
    //to refresh table

    //   if (applay.payload) {
    //     Swal.fire({
    //       position: "center",
    //       icon: "success",
    //       title: popUpText,
    //       showConfirmButton: false,
    //       //   timer: 1500,
    //       // width: "500px",
    //     });
    //     //to refresh table
    //   }
    // } else {
    //   Swal.fire({
    //     position: "center",
    //     icon: "error",
    //     title: validat.payload[0]?.code,
    //     showConfirmButton: true,
    //     confirmButtonText: "تأكيد",
    //     // timer: 1500,
    //     // width: "500px",
    //   });
    // }
  };
  console.log(
    state.ReportStatusByApplicationGuid,
    "dsascxczx",
    state.ReportByApp
  );

  const ValidateForTransfer = async (status) => {
    const validat = await dispatch(
      TransferValidationManagerEmployee({
        aI_ApplicationInformationId: props.applicationInformationGuid,
      })
    );

    if (validat.payload?.length == 0) {
      ApplayTransfer("bc7d23b3-2211-46ab-8957-c953f6dc6322", "اغلاق المناقلات");
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: validat.payload[0]?.code,
        showConfirmButton: true,
        confirmButtonText: "تأكيد",
        // timer: 1500,
        // width: "500px",
      });
    }
  };
  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(
      GetReportStatusByApplicationGuid(
        localStorage.getItem("aI_ApplicationInformationId_Manager")
      )
    );
  }, []);
  return props.applicationInformationGuid ? (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_TransferItemInformationGuid"}
        valueButtonAction={"pR_TransferItemInformationGuid"}
        URL={`api/TransferItemInformation/GetAllPR_TransferItemInformationFormManager`}
        UrlBody={{
          aI_ApplicationInformationId: props.applicationInformationGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        showIconsTransfer={true}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />

      <div className="containersButton">
        {state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid !=
          "984469c1-753a-4f9e-8ba9-39ef70f15542" &&
        state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid !=
          "80cd0c1e-b4d3-4fbf-acd5-5627c455915b" &&
        state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid !=
          "984469c1-753a-4f9e-8ba9-39ef70f15542" ? (
          <div>
            <ButtonAHSF
              type={"submitter"}
              onClick={() => {
                ApplayTransfer(
                  "80cd0c1e-b4d3-4fbf-acd5-5627c455915b",
                  "السماح بالمناقلات"
                );
              }}
              disabled={false}
              title={"السماح بالمناقلات"}
              text={"السماح بالمناقلات"}
              show={true}
            />
          </div>
        ) : (
          ""
        )}
        {state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid ==
          "984469c1-753a-4f9e-8ba9-39ef70f15542" ||
        state.ReportStatusByApplicationGuid?.pR_ReportStatusGuid ==
          "80cd0c1e-b4d3-4fbf-acd5-5627c455915b" ? (
          <>
            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  ValidateForTransfer("bc7d23b3-2211-46ab-8957-c953f6dc6322");
                  // ApplayTransfer(
                  //   "7411c9e6-e567-41fb-9505-d0eb08ef25dd",
                  //   "اغلاق المناقلات"
                  // );
                }}
                disabled={false}
                title={"  اغلاق المناقلات على الطلب"}
                text={"  اغلاق المناقلات على الطلب "}
                show={true}
              />
            </div>

            <div>
              <ButtonAHSF
                type={"submitter"}
                onClick={() => {
                  ApplayTransfer(
                    "8dd3e82f-6bc0-43d7-9439-8a63f655a263",
                    " ارجاع المناقلات الى التعديل"
                  );
                }}
                disabled={false}
                title={"ارجاع المناقلات الى التعديل"}
                text={"ارجاع المناقلات الى التعديل"}
                show={true}
              />
            </div>
          </>
        ) : (
          ""
        )}
      </div>

      {/* Popup for validation errors */}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)} // Close popup
        forValidate={true}
        maxWidth="50%"
        title="تنبيه"
        componentBody={state.ApplicationInformationValidationPage} // Validation messages
      />
    </>
  ) : (
    ""
  );
};
export default TransferItemInformationEmployee;
